class SmoothScroll {
  constructor(selector) {
    this.links = document.querySelectorAll(selector);
    this.addSmoothScroll();
  }

  addSmoothScroll() {
    this.links.forEach((link) => {
      link.addEventListener('click', this.handleClick.bind(link)); // Bind `this` to link element
    });
  }

  handleClick(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      });

      const url = new URL(window.location.href);
      url.hash = targetId;
      history.pushState({}, '', url);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const smoothScroll = new SmoothScroll('.js-scroll-to');
});
